import styled from "styled-components";

export const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: content-box;
  width: ${({ $width }) => ($width ? $width : "auto")};
  height: ${({ $height }) => ($height ? $height : "auto")};
  position: relative;

  ${({ $hoverColor }) =>
    $hoverColor &&
    `
    &:hover {
      color: ${$hoverColor};
    }
  `}

  > div {
    display: flex;
    width: 100%;
    height: 100%;
    color: inherit;
    pointer-events: none;
    justify-content: center;
    align-items: stretch;
  }

  svg {
    width: 100%;
    height: 100%;
    color: inherit; // passing color through to svg
    pointer-events: none;
    /*
     * Single site-wide stroke weight for all v2 icons. We treat declared
     * strokeWidth as a device-pixel target (not a viewBox unit that scales
     * with the SVG) via vector-effect. One-off overrides: pass a className
     * and target it from a stylesheet, e.g.
     *   <Icon className="bold-stroke" />
     *   .bold-stroke svg * { stroke-width: 2.25; }
     */
    stroke-width: 1.75;
    * {
      vector-effect: non-scaling-stroke;
    }
  }
`;
